let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1MHaT")).then(() => parcelRequire('gW3wf'));